var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoopColour2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #143223;\n      }\n\n      .st2 {\n        fill: #9b9b96;\n      }\n\n      .st3 {\n        fill: #27455e;\n      }\n\n      .st4 {\n        fill: #1e374b;\n      }\n\n      .st5 {\n        display: none;\n      }\n\n      .st6 {\n        fill: #20374c;\n      }\n\n      .st7 {\n        fill: #4e7698;\n      }\n\n      .st8 {\n        fill: #fffaf5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.98,23.84c0-3.3-2.68-5.98-5.98-5.98s-5.98,2.68-5.98,5.98h11.97-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.27,21.44c.16,0,.29.13.28.29-.15,5.7-4.82,10.27-10.56,10.27s-10.4-4.57-10.56-10.27c0-.16.13-.29.28-.29h20.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.4,8h19.15c.15,0,.28.13.28.28v5.28c0,2.37-1.92,4.29-4.29,4.29h-11.12c-2.37,0-4.29-1.92-4.29-4.29v-5.28c0-.15.13-.28.28-.28h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.29,15.6c1.63,0,2.96-1.32,2.96-2.96s-1.32-2.96-2.96-2.96-2.96,1.32-2.96,2.96,1.32,2.96,2.96,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.66,15.6c1.63,0,2.96-1.32,2.96-2.96s-1.32-2.96-2.96-2.96-2.96,1.32-2.96,2.96,1.32,2.96,2.96,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.29,14.16c.86,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.66,14.16c.86,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 23.62,
    cy: 15.07,
    r: 2.73
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 23.62,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16.36,
    cy: 15.07,
    r: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 23.62,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16.36,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 23.62,
    cy: 15.07,
    r: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 23.62,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16.36,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 23.62,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.99,31.06c2.13,0,3.85-1.72,3.85-3.85s-1.72-3.85-3.85-3.85-3.85,1.72-3.85,3.85,1.72,3.85,3.85,3.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 23.62,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16.36,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 23.62,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.99,31.06c2.13,0,3.85-1.72,3.85-3.85s-1.72-3.85-3.85-3.85-3.85,1.72-3.85,3.85,1.72,3.85,3.85,3.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 19.99,
    cy: 29.69,
    r: 0.59
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 23.62,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16.36,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 23.62,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.99,31.06c2.13,0,3.85-1.72,3.85-3.85s-1.72-3.85-3.85-3.85-3.85,1.72-3.85,3.85,1.72,3.85,3.85,3.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 19.99,
    cy: 29.69,
    r: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.95,19.61h.18c3.06,0,5.55,2.49,5.55,5.55v1.93c0,.13-.1.23-.23.23h-10.8c-.13,0-.23-.1-.23-.23v-1.93c0-3.06,2.49-5.55,5.55-5.55h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.43,19.61c.13,0,.24-.11.24-.24-.13-5.79-4.86-10.43-10.67-10.43s-10.55,4.65-10.67,10.43c0,.13.1.24.24.24h20.88,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 16.36,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 23.62,
    cy: 15.07,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 16.36,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 23.62,
    cy: 15.07,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.99,31.06c2.13,0,3.85-1.72,3.85-3.85s-1.72-3.85-3.85-3.85-3.85,1.72-3.85,3.85,1.72,3.85,3.85,3.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 19.99,
    cy: 29.69,
    r: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.95,19.61h.18c3.06,0,5.55,2.49,5.55,5.55v1.93c0,.13-.1.23-.23.23h-10.8c-.13,0-.23-.1-.23-.23v-1.93c0-3.06,2.49-5.55,5.55-5.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M13.71,11.96h5.34c.49,0,.89.4.89.89h0c0,.49-.4.89-.89.89h-5.34c-.49,0-.89-.4-.89-.89h0c0-.49.4-.89.89-.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoopColour2);
export default __webpack_public_path__ + "static/media/Boop-colour2.dc84cf2a0b84c48c18523dee1b061d45.svg";
export { ForwardRef as ReactComponent };